import withAPIAction from 'helpers/withAPIAction'
import { DeleteInquiryReq, DetailReq, UpdateReq } from './types'
import { getDeliveryCostAction, updateDeliveryCostAction, inquiryDeleteAction } from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const getDeliveryCostAPI = (data: DetailReq, token: string, xmid: string) => {
  return withAPIAction<DetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getDeliveryCost,
    data,
    token,
    xmid,
  })(getDeliveryCostAction)
}

export const updateDeliveryCostAPI = (data: UpdateReq, token: string, xmid: string) => {
  return withAPIAction<UpdateReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateDeliveryCost,
    data,
    token,
    xmid,
  })(updateDeliveryCostAction)
}

export const inquiryDeleteDeliveryCostAPI = (data: DeleteInquiryReq, token: string, xmid: string) => {
  return withAPIAction<DeleteInquiryReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.inquryDeleteDeliveryCost,
    data,
    token,
    xmid,
  })(inquiryDeleteAction)
}
